import { Text } from "preact-i18n";
import "../../style/Attachment.css";

const Attachment = ({ payLink }) => {
  const downloadFile = async () => {
    const fileUrl = payLink.metadata.attachments[0].url;
    const filename = fileUrl.split('/').pop();

    try {
      const response = await fetch(fileUrl, { mode: 'cors' });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed", error);
    }
  };

  return (
    <div className='invoice-attachment'>
      <img
        className='invoice-attachment-image'
        src={payLink.metadata.attachments[0].url}
        alt="Attachment preview"
      />
      <div>
        <span>
          <Text id="INVOICE_ATTACHMENT">Attachment</Text>
        </span>
        <br />
        <span className='invoice-attachment-name'>
          {payLink.metadata.attachments[0].url.split('/').pop()}
        </span>
      </div>
      <span
        className='invoice-attachment-download'
        onClick={downloadFile}
        style={{ cursor: 'pointer' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#111111" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
        </svg>
      </span>
    </div>
  );
};

export default Attachment;
